import { Component, OnInit } from '@angular/core';

import { GlobalService } from '../services/global.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';

import { Router, ActivatedRoute } from '@angular/router';
import { LoadingService } from '../shared/loading/loading.service';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css']
})

export class AdminComponent implements OnInit {

    public logoImage = localStorage.getItem('logoPhotoPath') && localStorage.getItem('logoPhotoPath').length > 1 ? 'https://hvswebuat1.hvsfinancial.com/portal/shared/' + localStorage.getItem('logoPhotoPath') : 'https://hvswebuat1.hvsfinancial.com/assets/images/temp/logo.png';
    public advisor: any;
    public organization: any = {
        Name: '',
        Address: '',
        Number: '',
        Email: '',
        DisclosureSS: '',
        DisclosureHC: '',
        DisclosureMMT: '',
        DisclosureLTC: '',
        Disclosure1: ''
    };

    public error: any;
    private selectedOrganization: number;

    constructor(private globalService: GlobalService, private router: Router, private snackbarService: SnackBarService, private loadingService: LoadingService) {

    }

    public isAxa: boolean;
    public isOAUser: boolean;
    public isOAAdmin: boolean;

    private organizations: any[];

    ngOnInit() {
        this.assignValuesToGlobalService();
        if (localStorage.getItem('roleId') != '2' && localStorage.getItem('roleId') != '1') {
            this.router.navigate(['/home']);
        } else {
            this.isAxa = (Number(localStorage.getItem('orgID')) === 421 || Number(localStorage.getItem('parentID')) === 421) ? true : false;
            this.isOAUser = (Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
            this.isOAAdmin = (Number(localStorage.getItem('orgID')) === 2 && (Number(localStorage.getItem('roleId')) === 2)) ? true : false;
            this.selectedOrganization = Number(localStorage.getItem("orgID"));
            this.getOrganizationsData();
            this.getData();
        }
    }

    assignValuesToGlobalService() {
        this.globalService.featSocialSecurity = JSON.parse(localStorage.getItem('featSocialSecurity'));
        this.globalService.featMeansTesting = JSON.parse(localStorage.getItem('featMeansTesting'));
        this.globalService.featHealthCare = JSON.parse(localStorage.getItem('featHealthCare'));
        this.globalService.featLongTermCare = JSON.parse(localStorage.getItem('featLongTermCare'));
        this.globalService.featCombinedHealthcareLTC = JSON.parse(localStorage.getItem('featCombinedHealthcareLTC'));
    }

    

    getData() {
        this.globalService.getAdvisorData(Number(localStorage.getItem("userId")))
            .subscribe(
                advisor => {
                    this.advisor = advisor;
                    
                    this.globalService.getOrganizationData(this.selectedOrganization)
                        .subscribe(
                            organization => {
                                this.organization = organization;

                                if (organization) {
                                    this.organization.DisclosureSS = this.organization.DisclosureSS ? this.organization.DisclosureSS.replace(new RegExp('<br />', 'g'), '\n') : '';
                                    this.organization.DisclosureMMT = this.organization.DisclosureMMT ? this.organization.DisclosureMMT.replace(new RegExp('<br />', 'g'), '\n') : '';
                                    this.organization.DisclosureHC = this.organization.DisclosureHC ? this.organization.DisclosureHC.replace(new RegExp('<br />', 'g'), '\n') : '';
                                    this.organization.DisclosureLTC = this.organization.DisclosureLTC ? this.organization.DisclosureLTC.replace(new RegExp('<br />', 'g'), '\n') : '';
                                    //Combined disclosure
                                    this.organization.Disclosure1 = this.organization.Disclosure1 ? this.organization.Disclosure1.replace(new RegExp('<br />', 'g'), '\n') : '';

                                    if (this.organization.Phone.indexOf("-") == -1 && this.organization.Phone.indexOf("(") == -1 && this.organization.Phone.indexOf(")") == -1) {
                                        this.onPhoneInputChange(this.organization.Phone, true);
                                    }

                                    if (typeof this.organization.LogoPath != 'object')
                                        this.logoImage = this.globalService.assetURL + this.organization.LogoPath;
                                    else
                                        this.logoImage = this.globalService.assetURL + localStorage.getItem('logoPhotoPath');
                                }
                            },
                            error => this.error = <any>error);
                },
                error => this.error = <any>error);
    }

    displayPreparedLogo(e) {
        const reader = new FileReader();
        this.file = e.target.files[0];
        reader.readAsDataURL(this.file);

        reader.onload = (test: any) => {
            this.logoImage = test.target.result;
        }
    }

    public file: File;

    uploadOrgLogo(e) {
        //this.file = e.target.files[0];
        let formData: FormData = new FormData();
        var date = new Date().getTime() / 1000;

        this.file = File = e.target.files[0];
        formData.append('uploadFile', this.file, this.advisor.OrganizationID + '_' + date + '_logo' + this.file.name.substring(this.file.name.lastIndexOf('.'), this.file.name.length));
        formData.append('Email', this.advisor.Email);
        formData.append('UserID', this.advisor.ID.toString());

        this.globalService.uploadOrgLogo(formData)
            .subscribe(
                data => {
                    localStorage.setItem('logoPhotoPath', data._body);
                    this.logoImage = localStorage.getItem('logoPhotoPath') !== 'null' ? this.globalService.assetURL + localStorage.getItem('logoPhotoPath') : 'https://web234.hvsfinancial.com/portal/assets/images/temp/logo.png';
                    //this.logoImage = "https://hvswebuat1.hvsfinancial.com/portal/shared/" + localStorage.getItem('logoPhotoPath');

                    this.snackbarService.add('Your company logo has been added successfully.', 0);
                    this.updateOrgInfo();
                },
                error => this.error = <any>error);
    }

    onPhoneInputChange(event, backspace) {
        let newVal = event.replace(/\D/g, '');
        if (backspace && newVal.length <= 6) {
          newVal = newVal.substring(0, newVal.length - 1);
        }
        if (newVal.length === 0) {
          newVal = '';
        } else if (newVal.length <= 3) {
          newVal = newVal.replace(/^(\d{0,3})/, '($1)');
        } else if (newVal.length <= 6) {
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
        } else if (newVal.length <= 10) {
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
        } else {
          newVal = newVal.substring(0, 10);
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
        }
        //this.ngControl.valueAccessor.writeValue(newVal);
        this.organization.Phone = newVal;
      }

    save() {
        this.loadingService.isLoading(true);

        this.globalService.updateOrgInfo(this.organization)
        .subscribe(
            data => {
                this.loadingService.isLoading(false);
                this.snackbarService.add('Your organization has been updated.', 0);
            },
            error => this.error = <any>error);
    }

    updateOrgInfo() {
        this.loadingService.isLoading(true);
        this.globalService.updateOrgInfo(this.organization)
        .subscribe(
            data => {
                this.loadingService.isLoading(false);
                this.snackbarService.add('Your organization has been updated.', 0);
            },
            error => this.error = <any>error);
    }


    getOrganizationsData() {
        this.globalService.getOrganizationsData()
            .subscribe(organizations => {
                var temp = [];

                organizations.forEach((org) => {
                    if (org.Name.length > 0) {
                        org.Name = org.Name.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
                        temp.push(org);
                    }
                });

                temp = temp.sort((a, b) => {
                    if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
                    if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
                    return 0;
                });

                this.organizations = temp;

            },
                error => this.error = <any>error);
    }

    cancel() {

    }

    handleOrgSelected() {
        this.getData();
    }
}
